/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import InfiniteCalendar from 'react-infinite-calendar'
import onClickOutside from 'react-onclickoutside'
import 'react-infinite-calendar/styles.css'

/**
 *     Import
 *     - Components
 */
import { CalendarIcon } from '../../../images/icons/Calendar/Calendar'

/**
 *     Import
 *     - Styles
 */
import './styles/DatePicker.css'

/**
 * DataPicker component
 *
 * @class DatePicker
 * @extends {React.Component<any, any>}
 */
class DatePicker extends React.Component<any, any> {
    /**
     * Creates an instance of DatePicker.
     * @param {*} props
     * @memberof DatePicker
     */
    constructor(props: any) {
        super(props)
        this.state = {
            active: false,
            dateSet: false,
            date: new Date(),
            index: this.props.index,
        }
    }

    /**
     * It will activate or not the calendar
     *
     * @param {*} event
     * @memberof DatePicker
     */
    showCalendar = (event: any) => {
        if (this.state.active) {
            this.setState({ active: false })
        } else {
            this.setState({ active: true })
            if (event.target.type === 'text') {
                this.props.onFocus(event)
            }
        }
    }

    /**
     * Will handle an outside click for closing the calendar
     *
     * @memberof DatePicker
     */
    handleClickOutside = (evt) => {
        this.setState({ active: false })
    }

    /**
     * Will hide the calendar
     *
     * @param {*} date
     * @memberof DatePicker
     */
    hideCalendar = (date: any) => {
        this.setState({ active: false, date: date, dateSet: true })
        this.props.onChange(this.getFormattedDateOutput(date), this.state.index)
    }

    /**
     * Will format the date output
     *
     * @param {*} date
     * @returns the date output to show
     * @memberof DatePicker
     */
    getFormattedDateOutput = (date: any) => {
        var newDate = new Date(date)
        // tslint:disable-next-line
        return `${('0' + newDate.getDate()).slice(-2)}-${('0' + (newDate.getMonth() + 1)).slice(-2)}-${newDate.getFullYear()}`
    }

    /**
     * Will format the Date with letter base month instead of numbers
     *
     * @param {*} date
     * @returns
     * @memberof DatePicker
     */
    getFormattedDate = (date: any) => {

        var newDate = new Date(date)

        var month = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ][newDate.getMonth()]

        return `${newDate.getDate()} ${month} ${newDate.getFullYear()}`
    }

    render() {

        let today = new Date()
        /**
         * Min limit for date
         */
        let dateMinDate = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate())

        let dateMaxDate = (this.props.mta) ?
            new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate() + 13)
            :
            new Date(
                today.getFullYear(),
                today.getMonth() + 1,
                today.getDate())

        let styles = {
            accentColor: '#448AFF',
            floatingNav: {
                background: 'rgba(56, 87, 138, 0.94)',
                chevron: '#fca61b',
                color: '#FFF',
            },
            headerColor: '#448AFF',
            selectionColor: '#4f73af',
            textColor: {
                active: '#FFF',
                default: '#333',
            },
            todayColor: '#fca61b',
            weekdayColor: '#4f73af',
        }

        if (this.props.mta && this.props.mtaData.policyInceptionDate) {
            dateMinDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate())

            let policyInception = this.props.mtaData.policyInceptionDate.split('-')

            let policyInceptionDate = new Date(
                parseInt('20' + policyInception[2], 10),
                policyInception[1] - 1,
                policyInception[0])

            let expiryDate = this.props.mtaData.expiryDate.split(' - ')

            let expiryDateFormatted = new Date(
                expiryDate[2],
                expiryDate[1] - 1,
                expiryDate[0])

            if (policyInceptionDate > dateMinDate && policyInceptionDate > today) {
                dateMinDate = policyInceptionDate
            }

            if (expiryDateFormatted < dateMaxDate && expiryDateFormatted > today) {
                dateMaxDate = expiryDateFormatted
            }

            this.props.mtaData.mtas.map((mta, index) => {
                let mtaDate = mta.effectiveDate.split(' - ')
                let mtaDateFormatted = new Date(
                    parseInt('20' + mtaDate[2], 10),
                    mtaDate[1] - 1,
                    mtaDate[0])

                if (mtaDateFormatted > dateMinDate && mtaDateFormatted > today) {
                    dateMinDate = mtaDateFormatted
                }

            })
        }

        if (this.props.claim) {
            dateMinDate = new Date(
                today.getFullYear() - 5,
                today.getMonth(),
                today.getDate())
            dateMaxDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate())

        }

        if (this.props.step05inceptionDate) {
            let inceptionDate =
                new Date(this.props.step05inceptionDate.replace(/(\d{2})\-(\d{2})\-(\d{4})/, '$3-$2-$1'))
            dateMinDate = today
            dateMaxDate = new Date(
                inceptionDate.getFullYear(),
                inceptionDate.getMonth(),
                inceptionDate.getDate() + 29)
        }

        if (this.props.retroDate) {
            dateMinDate = new Date(1300, 0, 1)
            dateMaxDate = today
        }

        const { showIcon = true, placeholderIsDate = false, placeholder = '', customClass = '', displayOptions = {
            layout: 'portrait',
            showOverlay: false,
            shouldHeaderAnimate: false,
            showHeader: false,
            showTodayHelper: false,
        } } = this.props

        return (
            <div className={`${(this.state.active) ? 'active' : ''} ${customClass}`}>
                <div>
                    <input
                        type="text"
                        value={
                            (this.state.dateSet)
                                ? this.getFormattedDate(this.state.date)
                                : placeholderIsDate ? this.getFormattedDate(placeholder) : placeholder
                        }
                        onClick={this.showCalendar}
                        readOnly={true}
                        className="calendar__input"
                    />
                    {showIcon &&
                        <div
                            className="calendar__icon"
                            onClick={this.showCalendar}
                        >
                            <CalendarIcon />
                        </div>
                    }
                    <div className={`calContainer ${(this.state.active) ? 'active' : ''}`}>
                        <InfiniteCalendar
                            width={'100%'}
                            height={250}
                            selected={this.props.dateSelected || this.state.date}
                            min={dateMinDate}
                            minDate={dateMinDate}
                            maxDate={dateMaxDate}
                            onSelect={this.hideCalendar}
                            theme={styles}
                            className={`calendar ${(this.state.active) ? 'active' : ''}`}
                            displayOptions={displayOptions}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default onClickOutside(DatePicker)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/DatePicker/DatePicker.tsx